import request from 'shared/lib/request';
import { useMutation, useQuery } from '@tanstack/react-query';
import { showMessage } from 'shared/feedback/messages';
import { i18n } from 'shared/i18n';
import ServerErrorHandler from 'shared/feedback/ErrorHandler';
import { listKeys } from './keys';

export function useLists() {
  return useQuery({
    queryKey: listKeys.list(),

    queryFn: async () => {
      const res = await request.get(`/foundation/lists?size=1000`).catch((err) => {
        if (err.status === 404) {
          return null;
        } else {
          throw err;
        }
      });

      return res?.data?._embedded?.userDefinedLists || [];
    },
  });
}

export function useList(id: number | string) {
  return useQuery({
    queryKey: listKeys.detail(id),

    queryFn: async () => {
      const res = await request.get(`/foundation/lists/${id}`).catch((err) => {
        if (err.status === 404) {
          return null;
        } else {
          throw err;
        }
      });

      return res?.data;
    },
  });
}

export function useCreateList() {
  return useMutation({
    mutationFn: async ({ code, name }: { code: string; name: string }) => {
      return await request
        .post(`/foundation/lists`, { code, name })
        .then((response) => response?.headers?.Location)
        .then((location) => {
          if (location) {
            return request.get(location).then((response) => response.data);
          }

          return;
        });
    },

    onError: ServerErrorHandler,

    onSuccess: () => {
      showMessage('success', i18n('lists:created'));
    },
  });
}

export function useUpdateList(id: number | string) {
  return useMutation({
    mutationFn: async (list: unknown) => {
      return await request.put(`/foundation/lists/${id}`, list).then((response) => {
        return response.data;
      });
    },

    onError: ServerErrorHandler,

    onSuccess: () => {
      showMessage('success', i18n('lists:updated'));
    },
  });
}
